import React from "react";

function WhatWeDo() {
  return (
    <div>
      {" "}
      <section class="bg-white ">
        <div class="py-8 lg:py-16 mx-auto max-w-screen-xl px-4">
          <h2 class="mb-8 lg:mb-16 text-3xl font-extrabold tracking-tight leading-tight text-center text-gray-900 ">
            What we do
          </h2>
          <div
            className=" 
                 md:flex flex-row md:space-x-4 w-full text-xs mt-8  
                 "
          >
            <div class="max-w-sm bg-white border hover: border-gray-200 rounded-lg shadow  w-full flex flex-col mb-3  hover:shadow-2xl">
              <a href="/masstrain">
                <img
                  class="rounded-t-lg h-56 w-96 ..."
                  src="./image/Picts for Galary/Mass training 5.jpg"
                  alt=""
                />
              </a>
              <div class="p-5">
                <a href="/masstrain">
                  <h5 class="mb-2 text-2xl font-bold tracking-tight text-gray-900 ">
                    Mass Training
                  </h5>
                </a>
                <p class="mb-3 font-normal text-gray-700 ">
                  We developed this program to offer group training sessions
                  that focus on Orthodox mindset, work culture, and professional
                  development ...
                </p>
                <a href="/masstrain">
                  <button class="inline-flex items-center px-3 py-2 text-sm font-medium text-center text-white bg-blue-500 rounded-lg hover:bg-blue-400 focus:ring-4 focus:outline-none ">
                    Read more
                    <svg
                      aria-hidden="true"
                      class="w-4 h-4 ml-2 -mr-1"
                      fill="currentColor"
                      viewBox="0 0 20 20"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        fill-rule="evenodd"
                        d="M10.293 3.293a1 1 0 011.414 0l6 6a1 1 0 010 1.414l-6 6a1 1 0 01-1.414-1.414L14.586 11H3a1 1 0 110-2h11.586l-4.293-4.293a1 1 0 010-1.414z"
                        clip-rule="evenodd"
                      ></path>
                    </svg>
                  </button>
                </a>
              </div>
            </div>
            <div class="max-w-sm bg-white border border-gray-200 rounded-lg shadow  w-full flex flex-col mb-3  hover:shadow-2xl">
              <a href="/vocationatrain">
                <img
                  class="rounded-t-lg h-56 w-96 ..."
                  src="./image/food.jpg"
                  alt=""
                />
              </a>
              <div class="p-5">
                <a href="/vocationatrain">
                  <h5 class="mb-2 text-2xl font-bold tracking-tight text-gray-900 ">
                    Vocational skills training
                  </h5>
                </a>
                <p class="mb-3 font-normal text-gray-700 ">
                  We developed this program to provide vocational skills
                  training customized ....
                </p>
                <a href="/vocationatrain">
                  <button class="inline-flex items-center px-3 py-2 text-sm font-medium text-center text-white bg-blue-500 rounded-lg hover:bg-blue-400 focus:ring-4 focus:outline-none ">
                    Read more
                    <svg
                      aria-hidden="true"
                      class="w-4 h-4 ml-2 -mr-1"
                      fill="currentColor"
                      viewBox="0 0 20 20"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        fill-rule="evenodd"
                        d="M10.293 3.293a1 1 0 011.414 0l6 6a1 1 0 010 1.414l-6 6a1 1 0 01-1.414-1.414L14.586 11H3a1 1 0 110-2h11.586l-4.293-4.293a1 1 0 010-1.414z"
                        clip-rule="evenodd"
                      ></path>
                    </svg>
                  </button>
                </a>
              </div>
            </div>
            <div class="max-w-sm bg-white border border-gray-200 rounded-lg shadow  w-full flex flex-col mb-3  hover:shadow-2xl">
              <a href="/seeding">
                <img
                  class="rounded-t-lg h-56 w-96 ..."
                  src="https://img.freepik.com/free-photo/plants-with-coins-stacked-dirt-banknote_23-2148803946.jpg?w=740&t=st=1692534389~exp=1692534989~hmac=125d7474d9619e3e45b88721fb2425a4f4a1e590a30eae1acc7c632eca78e338"
                  alt=""
                />
              </a>
              <div class="p-5">
                <a href="/seeding">
                  <h5 class="mb-2 text-2xl font-bold tracking-tight text-gray-900 ">
                    Seed Funding
                  </h5>
                </a>
                <p class="mb-3 font-normal text-gray-700 ">
                  This program will support youth of the church who demonstrate
                  entrepreneurial skills, opportunities, and dedication but lack
                  the appropriate ...
                </p>
                <a href="/seeding">
                  <button class="inline-flex items-center px-3 py-2 text-sm font-medium text-center text-white bg-blue-500 rounded-lg hover:bg-blue-400 focus:ring-4 focus:outline-none ">
                    Read more
                    <svg
                      aria-hidden="true"
                      class="w-4 h-4 ml-2 -mr-1"
                      fill="currentColor"
                      viewBox="0 0 20 20"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        fill-rule="evenodd"
                        d="M10.293 3.293a1 1 0 011.414 0l6 6a1 1 0 010 1.414l-6 6a1 1 0 01-1.414-1.414L14.586 11H3a1 1 0 110-2h11.586l-4.293-4.293a1 1 0 010-1.414z"
                        clip-rule="evenodd"
                      ></path>
                    </svg>
                  </button>
                </a>
              </div>
            </div>
            <div class="max-w-sm bg-white border border-gray-200 rounded-lg shadow  w-full flex flex-col mb-3  hover:shadow-2xl">
              <a href="/businessnetwork">
                <img
                  class="rounded-t-lg h-56 w-96 ..."
                  src="./image/meeting.jpg"
                  alt=""
                />
              </a>
              <div class="p-5">
                <a href="/businessnetwork">
                  <h5 class="mb-2 text-2xl font-bold tracking-tight text-gray-900 ">
                    Digital Business Network
                  </h5>
                </a>
                <p class="mb-3 font-normal text-gray-700 ">
                  This program focuses on creating a digital business network
                  for EOTC members ...
                </p>
                <a href="/businessnetwork">
                  <button class="inline-flex items-center px-3 py-2 text-sm font-medium text-center text-white bg-blue-500 rounded-lg hover:bg-blue-400 focus:ring-4 focus:outline-none ">
                    Read more
                    <svg
                      aria-hidden="true"
                      class="w-4 h-4 ml-2 -mr-1"
                      fill="currentColor"
                      viewBox="0 0 20 20"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        fill-rule="evenodd"
                        d="M10.293 3.293a1 1 0 011.414 0l6 6a1 1 0 010 1.414l-6 6a1 1 0 01-1.414-1.414L14.586 11H3a1 1 0 110-2h11.586l-4.293-4.293a1 1 0 010-1.414z"
                        clip-rule="evenodd"
                      ></path>
                    </svg>
                  </button>
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}

export default WhatWeDo;
